import $ from "jquery";
import CONFIG from "@bd-core/config";
import GameLogic from "@bd-core/game-logic";
import BD_Component from "../core/bd-component";
import compile from "../utils/handlerbars-helper";
import {
    getFinalRoomAnswers,
    maybeUpdateRoomStatus,
    setRoomTotalScores,
    setTeamLogos,
    setTotalAttempt,
    updateCurrentScreen,
    updateFinalRoomAnswer,
} from "@bd-core/firebase-actions";
import {
    getCurrentOpenedChat,
    getCurrentRoomScreen,
    getFinalTeamAnswers,
    getIsRoomTimeOut,
    getRoomLogo,
    getRoomScore,
    getTotalAttempt,
    isLeader,
} from "@bd-stores/game-progress";
import Storage from "@bd-utils/storage";
import { isTestMode } from "@bd-utils/test-mode";
import fb from "@bd-core/firebase";

export class RoomQualityChats extends BD_Component {
    constructor() {
        super();

        this.id = "quality_chats";
        this.templateID = "quality_chats-template";

        this.elms = {
            // narrative popup
            narrativePopup: ".js-narrative-popup",
            narrativeCloseBtn: ".js-close-narrative-popup",

            // reward screen
            rewardScreen: ".js-reward-feedback",
            rewardTitle: ".js-reward-title",
            rewardSubtitle: ".js-reward-subtitle",
            rewardDescription: ".js-reward-description",
            rewardScore: ".js-reward-score",
            rewardContinueBtn: ".js-reward-continue-btn",
            triggerRewardScreenBtn: ".btn-continue-reward-screen",

            // customization
            customizationScreen: ".js-customization",
            customRewardWrapper: ".challange-prize__item-wrapper",
            customizationContinueBtn: ".js-customization-continue-btn",
            customizationCategory: ".js-category",
            logoImage: ".js-logo",

            // puzzle
            puzzleScreen: ".js-puzzle-screen",
            chatBtn: ".js-chat-button",
            chatPopup: ".js-chat-popup",
            chatList: ".js-chat-list",
            chatItem: ".js-chat-item",
            chatCount: ".js-chat-count",
            userData: ".js-user-data",
            timeInfo: ".js-time",
            readStatus: ".js-read-status",
            chatUsername: ".js-username",
            listMessage: ".js-list-message",
            inputMessage: ".js-input-message",
            interaction: ".js-interaction",
            lastMessage: ".js-last-message",
            answers: ".js-answers",
            showAnswerBtn: ".js-show-answer",
            submitAnswerBtn: ".js-submit-answer",
            typingInfo: ".js-typing-animation",
            userTyping: ".js-user-typing",
            kpiWrapper: ".js-kpi-wrapper",
            kpiDiagram: ".js-kpi-diagram",
            kpiItem: ".js-kpi-item",
            kpiItemSlider: ".js-kpi-item-slider",
            kpiItemFiller: ".js-kpi-item-filler",
            continueBtn: ".js-continue-button",
        };

        this._events = this.getEvents();

        this._data = {};

        this.isTeamLeader = CONFIG.game.is_leader;

        this.meSubmitting = false;
    }

    /**
     * @returns {Array<BD_ComponentEvent>}
     */
    getEvents() {
        const elms = this.elms;
        return [
            {
                event: "click",
                selector: elms.chatBtn,
                handler: this.openChat,
            },
            {
                event: "click",
                selector: elms.chatItem,
                handler: this.openUserChat,
            },
            {
                event: "click",
                selector: elms.showAnswerBtn,
                handler: this.showAnswers,
            },
            {
                event: "click",
                selector: elms.submitAnswerBtn,
                handler: this.submitAnswer,
            },
            {
                event: "click",
                selector: elms.continueBtn,
                handler: this.maybeRoomIsFinished,
            },
            {
                event: "click",
                selector: elms.triggerRewardScreenBtn,
                handler: this.goToRewardScreen,
            },
            {
                event: "click",
                selector: elms.rewardContinueBtn,
                handler: this.goToCustomizationScreen,
            },
            {
                event: "click",
                selector: elms.customizationContinueBtn,
                handler: this.setSelectedLogo,
            },
            {
                event: "click",
                selector: elms.narrativeCloseBtn,
                handler: this.closeNarrativePopup,
            },
        ];
    }

    beforeInit() {
        this.render();
        this.setGameState();
        this.setupSlider();
        this.setTestMode();
    }

    getModifiedData() {
        const roomData = this._data;

        const modifiedData = {
            ...roomData,
            isLeader: isLeader(),
        };

        return modifiedData;
    }

    render() {
        const modifiedData = this.getModifiedData();
        const htmlTemplate = $("#" + this.templateID).html();
        const html = compile(htmlTemplate, modifiedData);

        $(".app").html(html);
    }

    setTestMode() {
        if (isTestMode()) {
            $(this.elms.continueBtn).removeClass("disabled");
            $(".app__back").removeClass("hidden");
        }
    }

    setGameState() {
        const roomId = this.roomId;
        const elms = this.elms;
        const is_leader = isLeader();
        const $kpiItemsSlider = $(elms.kpiItemSlider);
        const $chatItems = $(elms.chatItem);
        const $continueBtn = $(elms.continueBtn);
        const { conversations } = this._data;
        const totalConversations = conversations.length;

        const $finance = $(`${elms.kpiItem}.finance`).find(elms.kpiItemFiller);
        const $time = $(`${elms.kpiItem}.time`).find(elms.kpiItemFiller);
        const $quality = $(`${elms.kpiItem}.quality`).find(elms.kpiItemFiller);

        const $finance_class = $(`${elms.kpiItem}.finance`).find(
            elms.kpiItemSlider,
        );
        const $time_class = $(`${elms.kpiItem}.time`).find(elms.kpiItemSlider);
        const $quality_class = $(`${elms.kpiItem}.quality`).find(
            elms.kpiItemSlider,
        );

        const roomAnswers = getFinalTeamAnswers(roomId);
        // @ts-ignore
        const kpis_score = roomAnswers?.kpi_data || {};
        // @ts-ignore
        const savedConversations = roomAnswers?.answers || {};

        $.each($chatItems, function (index, item) {
            const $lastMsg = $(item).find(elms.lastMessage);
            $lastMsg.find("p").hide();
            $lastMsg.find("p").last().show();
        });

        const currentOpenedChat = getCurrentOpenedChat();
        if (!is_leader && currentOpenedChat) {
            const chatId = currentOpenedChat;
            const $chatItem = $(`${elms.chatItem}[data-id="${chatId}"]`);
            const isAnswered = $chatItem.hasClass("be-read");

            if (!isAnswered) $chatItem.trigger("click");
        }

        $kpiItemsSlider.removeClass("low medium high");

        if (Object.keys(kpis_score).length > 0) {
            $finance.css("width", `${(kpis_score.finance * 100) / 4 - 25}%`);
            $time.css("width", `${(kpis_score.time * 100) / 4 - 25}%`);
            $quality.css("width", `${(kpis_score.quality * 100) / 4 - 25}%`);

            const financeClass = this.getKpiClass(kpis_score.finance);
            const timeClass = this.getKpiClass(kpis_score.time);
            const qualityClass = this.getKpiClass(kpis_score.quality);

            $finance_class.addClass(financeClass);
            $time_class.addClass(timeClass);
            $quality_class.addClass(qualityClass);
        }

        const totalSavedConversations = Object.keys(savedConversations).length;
        if (totalSavedConversations > 0) {
            $.each(savedConversations, function (index) {
                const chatId = String(index);
                const $chatItem = $(`${elms.chatItem}[data-id="${chatId}"]`);
                const $nextChat = $chatItem.next();

                $chatItem.removeClass("hidden");
                $chatItem.addClass("be-read active");
                $chatItem.find(elms.readStatus).addClass("hidden");

                $nextChat.addClass("active");
            });

            if (is_leader && totalConversations == totalSavedConversations) {
                $continueBtn.removeClass("disabled");
            }
        }

        /* force players to be on the same screen */
        const currentScreen = getCurrentRoomScreen(roomId);

        switch (currentScreen) {
            // case "search-find":
            //     $(".narrative-layer").show();
            //     $(".search-and-find-bg").show();
            //     break;
            case "reward-screen":
                this.goToRewardScreen();
                break;
            case "customisations-screen":
                this.goToCustomizationScreen();
                break;
            case "puzzle-screen":
                $(elms.rewardScreen).removeClass("active");
                $(elms.customizationScreen).removeClass("active");
                this.openChat();
                break;
            default:
            //
        }
        /* END: force players to be on the same screen */

        const isRoomTimeout = getIsRoomTimeOut(roomId);
        if (isRoomTimeout && isLeader()) {
            $continueBtn.removeClass("disabled");
        }
    }

    setupSlider() {
        $(".slick-slider").slick("refresh");
        const sliderSourcePopup = {
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: false,
            dots: true,
            customPaging: function (slider, i) {
                return "<a>" + (i + 1) + "</a>";
            },
            appendDots: $(".source-popup__nav-item.nav-pagination"),
            prevArrow: $(".source-popup__nav-item.nav-left"),
            nextArrow: $(".source-popup__nav-item.nav-right"),
        };

        const sliderInfoPopup = {
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: false,
            dots: true,
            customPaging: function (slider, i) {
                return "<a>" + (i + 1) + "</a>";
            },
            appendDots: $(".msn-popup__nav-item.nav-pagination"),
            prevArrow: $(".msn-popup__nav-item.nav-left"),
            nextArrow: $(".msn-popup__nav-item.nav-right"),
        };

        $(".js-info-slider-wrapper").slick(sliderInfoPopup);
        $(".js-source-wrapper").slick(sliderSourcePopup);
    }

    toggleInstructionPopup() {
        let roomId = this.roomId;

        // fix https://www.pivotaltracker.com/story/show/186872215
        if (!isNaN(parseInt(roomId.toString()))) {
            roomId = parseInt(roomId.toString());
        }

        let states = Storage.get("states", {});
        if (!states?.briefing) states.briefing = [];

        if (!states.briefing.includes(roomId)) {
            GameLogic.toggleBriefing();
        }
    }

    openChat() {
        const self = this;
        const elms = this.elms;
        const $puzzleScreen = $(elms.puzzleScreen);
        const $chatPopup = $(elms.chatPopup);
        // const $chatItems = $(elms.chatItem);
        const $kpiWrapper = $(elms.kpiWrapper);
        const isTeamLeader = isLeader();

        this.toggleInstructionPopup();

        $puzzleScreen.addClass("active");
        $chatPopup.addClass("active");
        $kpiWrapper.addClass("active");

        setTimeout(function () {
            self.hideConversations();
            $(elms.chatList).animate({
                scrollTop: $(elms.chatList).prop("scrollHeight"),
            });
        }, 300);

        if (isTeamLeader) updateCurrentScreen(this.roomId, "puzzle-screen");
    }

    hideConversations() {
        const elms = this.elms;
        const $firstChat = $(elms.chatList).find(
            `${elms.chatItem}:first-child`,
        );
        const $allReads = $(elms.chatList).find(`${elms.chatItem}.be-read`);
        const $lastRead = $(elms.chatList)
            .find(`${elms.chatItem}.be-read`)
            .last();

        $(elms.chatItem).removeClass("hidden");

        setTimeout(() => {
            $allReads.addClass("active");
        }, 100);

        const dateTime = new Date();
        const initialTime =
            String(dateTime.getHours()).padStart(2, "0") +
            ":" +
            String(dateTime.getMinutes()).padStart(2, "0");
        const savedConversations = this.getSavedConversation();

        if ($allReads.length > 0) {
            const chatId = $lastRead.attr("data-id");
            const savedChatId = savedConversations?.[chatId] || {};

            if (Object.keys(savedChatId).length > 0) {
                if ($lastRead.next().length > 0) {
                    $lastRead.next().find(elms.timeInfo).text(initialTime);
                    $lastRead.next().removeClass("hidden");

                    setTimeout(() => {
                        $lastRead.next().addClass("active");
                    }, 100);

                    $(elms.chatCount).html("1");
                }
            } else {
                $(elms.chatCount).html("0");
            }
        } else {
            $firstChat.find(elms.timeInfo).text(initialTime);
            $firstChat.removeClass("hidden").addClass("active");
            $(elms.chatCount).html("1");
        }
    }

    openUserChat(e, $el) {
        e.preventDefault();

        const roomId = this.roomId;
        const self = this;
        const elms = self.elms;
        const $answers = $(elms.answers);
        const chatId = $el.attr("data-id");
        const { conversations } = this._data;
        const $listMessage = $(elms.listMessage);
        const $inputMsg = $(elms.inputMessage);
        const $showAnswer = $(elms.showAnswerBtn);
        const $username = $(elms.chatUsername);
        const $typingInfo = $(elms.typingInfo);
        const $userTyping = $(elms.userTyping);
        const $chatCount = $(elms.chatCount);
        const $allChats = $(elms.chatItem);
        const is_leader = isLeader();
        let response = "";

        if ($el.hasClass("typing")) {
            $typingInfo.removeClass("hidden");
            $showAnswer.addClass("hidden").prop("disabled", true);

            const longAnswer = $el.attr("data-answer-long");

            setTimeout(() => {
                $listMessage.append(
                    `<div class="interaction js-interaction"></div>`,
                );
                const longResponse = `<p class="long">${longAnswer}</p>`;
                $listMessage.find(elms.interaction).append(longResponse);
            }, 100);

            setTimeout(() => {
                $(elms.interaction).addClass("active");
            }, 200);
        } else {
            $typingInfo.addClass("hidden");
            $showAnswer.removeClass("hidden").prop("disabled", false);
        }

        $answers.html("");
        $showAnswer.addClass("hidden").prop("disabled", false);

        $listMessage.animate({ scrollTop: $listMessage.prop("scrollHeight") });

        const roomAnswers = getFinalTeamAnswers(roomId);
        // @ts-ignore
        const savedConversations = roomAnswers?.answers || {};

        if (Object.keys(savedConversations).length > 0) {
            let response = "";
            const theChat = savedConversations?.[chatId] || {};

            if (Object.keys(theChat).length > 0) {
                $el.find(elms.lastMessage).html(
                    `<p>${theChat.answer_response}</p>`,
                );

                response += `<div class="interaction js-interaction">
                                <p class="long">${theChat.answer_long}</p>
                                <p class="response">${theChat.answer_response}</p>
                            </div>`;

                setTimeout(() => {
                    $listMessage.append(response);
                }, 100);

                setTimeout(() => {
                    $(elms.interaction).addClass("active");
                }, 200);

                $(elms.typingInfo).addClass("hidden");
                $(elms.showAnswerBtn).addClass("hidden").prop("disabled", true);
            } else {
                if ($el.hasClass("typing")) {
                    $(elms.typingInfo).removeClass("hidden");
                    $(elms.showAnswerBtn)
                        .addClass("hidden")
                        .prop("disabled", true);
                } else {
                    $(elms.typingInfo).addClass("hidden");
                    $(elms.showAnswerBtn)
                        .removeClass("hidden")
                        .prop("disabled", false);
                }
            }
        } else {
            if (!$el.hasClass("typing")) {
                $showAnswer.removeClass("hidden");
            } else {
                $showAnswer.addClass("hidden");
            }
        }

        if (conversations) {
            $.each(conversations, function (index, item) {
                if (item.id == chatId) {
                    const time = $el.find(elms.timeInfo).text();

                    if (!$el.hasClass("be-read")) {
                        $el.find(elms.readStatus).addClass("hidden");
                        $el.addClass("be-read");

                        $allChats.removeClass("is-open");
                        $el.addClass("is-open");

                        if (self._data.receiving_audio) {
                            const receivingAudio =
                                document.createElement("audio");
                            receivingAudio.setAttribute(
                                "src",
                                this._data.receiving_audio,
                            );
                            receivingAudio.play();
                        }
                    }

                    const { intro_text, contact_name } = item;

                    $listMessage.html("");
                    $inputMsg.removeClass("hidden");
                    $username.html(contact_name);
                    $userTyping.html(contact_name);

                    response += `<span class="time js-time">Today ${time} </span>`;
                    response += `<div class="intro-chat" data-id="${chatId}">${intro_text}</div>`;

                    $listMessage.removeClass("active").append(response);

                    setTimeout(() => {
                        $listMessage.addClass("active");
                    }, 100);

                    $chatCount.html("0");
                }
            });
        }

        if (is_leader)
            fb.update(`${fb.roomsPath}/${roomId}`, {
                currentOpenedChat: chatId,
            });
    }

    showAnswers(e, $el) {
        e.preventDefault();

        const is_leader = isLeader();
        if (!is_leader) return;

        const elms = this.elms;
        const { conversations } = this._data;
        const chatId = $(".intro-chat").attr("data-id");
        let stringAnswers = "";

        $el.addClass("hidden");
        if (conversations) {
            $.each(conversations, function (index, item) {
                if (item.id == chatId) {
                    const { answers } = item;
                    const $answers = $(elms.answers);
                    let answer_id = "";
                    let answer_short = "";
                    let answer_long = "";

                    $answers.html("");

                    $.each(answers, function (index, item) {
                        answer_id = String(index);
                        answer_short = item.answer_short;
                        answer_long = item.answer_long;

                        stringAnswers += `<a class="answer-item js-submit-answer" href="#" data-id="${answer_id}" data-answer-long="${answer_long}" data-chat-id="${chatId}">${answer_short}</a>`;
                    });

                    $answers.append(stringAnswers);
                    $answers
                        .children("a")
                        .animate(
                            {
                                top: 0,
                            },
                            500,
                        )
                        .fadeIn(200);

                    $el.fadeOut(200);
                }
            });
        }
    }

    showTyping() {
        const $typingInfo = $(this.elms.typingInfo);
        $typingInfo.removeClass("hidden");
    }

    hideTyping() {
        const $typingInfo = $(this.elms.typingInfo);
        $typingInfo.addClass("hidden");
    }

    setSavedConversations(chatObj) {
        let states = Storage.get("states", {});
        let conversationsStates = states?.conversations || {};

        conversationsStates = {
            ...conversationsStates,
            ...chatObj,
        };

        states.conversations = conversationsStates;
        return Storage.set("states", states);
    }

    getSavedConversation(chatId = null) {
        let states = Storage.get("states", {});
        const savedConversation = states?.conversations || {};

        if (chatId !== null) {
            return savedConversation?.[chatId] || {};
        }

        return savedConversation;
    }

    submitAnswer(e, $el) {
        e.preventDefault();
        const isTeamLeader = isLeader();

        if (!isTeamLeader) return;

        const self = this;
        const elms = self.elms;
        const chatId = $el.attr("data-chat-id");
        const answerId = $el.attr("data-id");
        const $theChat = $(`${elms.chatItem}[data-id=${chatId}]`);
        const $listMessage = $(elms.listMessage);
        const answerLong = $el.attr("data-answer-long");
        let stringFeedback = "";
        let stringResponse = "";

        const date = new Date();
        const currentTime =
            String(date.getHours()).padStart(2, "0") +
            ":" +
            String(date.getMinutes()).padStart(2, "0");

        $theChat.addClass("typing");
        $theChat.attr("data-answer-long", answerLong);

        this.meSubmitting = true;

        // kpis diagram
        const $finance = $(`${elms.kpiItem}.finance`).find(elms.kpiItemFiller);
        const $time = $(`${elms.kpiItem}.time`).find(elms.kpiItemFiller);
        const $quality = $(`${elms.kpiItem}.quality`).find(elms.kpiItemFiller);

        // kpis diagram slider
        const $finance_class = $(`${elms.kpiItem}.finance`).find(
            elms.kpiItemSlider,
        );
        const $time_class = $(`${elms.kpiItem}.time`).find(elms.kpiItemSlider);
        const $quality_class = $(`${elms.kpiItem}.quality`).find(
            elms.kpiItemSlider,
        );

        $listMessage.animate({ scrollTop: $listMessage.prop("scrollHeight") });

        $(elms.answers).find(elms.submitAnswerBtn).remove();

        if (self._data.sending_audio) {
            const sendingAudio = document.createElement("audio");
            sendingAudio.setAttribute("src", this._data.sending_audio);
            sendingAudio.play();
        }

        stringFeedback = `<div class="interaction js-interaction"></div>`;
        $listMessage.append(stringFeedback);

        stringResponse = `<p class="long">${answerLong}</p>`;

        $(elms.interaction).removeClass("active").append(stringResponse);

        setTimeout(() => {
            $(elms.interaction).addClass("active");
        }, 100);

        // show typing animation
        self.showTyping();

        const roomId = this.roomId;
        const roomAnswers = getFinalTeamAnswers(roomId);

        // @ts-ignore
        const savedKpisScore = roomAnswers?.kpi_data;
        const { kpis_score, conversations } = this._data;
        const kpi_data = {
            finance: savedKpisScore
                ? savedKpisScore?.finance
                : kpis_score.finance.start_score,
            time: savedKpisScore
                ? savedKpisScore?.time
                : kpis_score.time.start_score,
            quality: savedKpisScore
                ? savedKpisScore?.quality
                : kpis_score.quality.start_score,
        };

        // @ts-ignore
        const savedPlayerAnswers = roomAnswers?.answers || {};
        const theAnsweredChat = savedPlayerAnswers?.[chatId] || {};
        const isAnswered = Object.keys(theAnsweredChat).length > 0;
        if (isAnswered) {
            self.hideTyping();
            alert("You have answered this question");
            return false;
        }

        const conversationData = conversations.find((item) => {
            return item.id === chatId;
        });

        const { answers } = conversationData;
        const theAnswer = answers?.[answerId];
        let { influence_on_kpis, answer_response } = theAnswer;

        influence_on_kpis = {
            ...influence_on_kpis,
            finance: Number(influence_on_kpis.finance),
            time: Number(influence_on_kpis.time),
            quality: Number(influence_on_kpis.quality),
        };

        const updatedKpiScore = {
            ...kpi_data,
            finance: Number(kpi_data.finance) + influence_on_kpis.finance,
            time: Number(kpi_data.time) + influence_on_kpis.time,
            quality: Number(kpi_data.quality) + influence_on_kpis.quality,
        };

        const updatedKpiScoreWidth = {
            finance: (updatedKpiScore.finance * 100) / 4 - 25,
            time: (updatedKpiScore.time * 100) / 4 - 25,
            quality: (updatedKpiScore.quality * 100) / 4 - 25,
        };

        $.each(updatedKpiScore, function (index, item) {
            if (item < 1) updatedKpiScore[index] = 1;

            if (item > 5) updatedKpiScore[index] = 5;
        });

        const updateKpiClass = {
            finance: self.getKpiClass(updatedKpiScore.finance),
            time: self.getKpiClass(updatedKpiScore.time),
            quality: self.getKpiClass(updatedKpiScore.quality),
        };

        const updatedRoomStatus = "is-status-started";
        let totalAttempt = getTotalAttempt(roomId);
        totalAttempt++;

        // const playerAnswers = {
        //     ...savedPlayerAnswers,
        //     [chatId]: {
        //         answer: answerId,
        //         time: currentTime,
        //     },
        // };

        const chatObj = {
            ...savedPlayerAnswers,
            [chatId]: {
                answer_id: answerId,
                answer_long: answerLong,
                answer_response: answer_response,
                time: currentTime,
            },
        };

        const updatedData = {
            answers: chatObj,
            kpi_data: updatedKpiScore,
        };

        setTimeout(() => {
            // stop typing animation
            self.hideTyping();

            $theChat.removeClass("typing");
            $theChat.removeAttr("data-answer-long");

            if (self._data.receiving_audio) {
                const receivingAudio = document.createElement("audio");
                receivingAudio.setAttribute("src", this._data.receiving_audio);
                receivingAudio.play();
            }

            stringResponse = `<p class="response">${answer_response}</p>`;
            $(elms.interaction).removeClass("active").append(stringResponse);

            setTimeout(() => {
                $(elms.interaction).addClass("active");
            }, 100);

            $listMessage.animate({
                scrollTop: $listMessage.prop("scrollHeight"),
            });

            // need to handle continue button here

            const kpiFinance =
                influence_on_kpis.finance > 0
                    ? `+${influence_on_kpis.finance}`
                    : influence_on_kpis.finance;
            const kpiTime =
                influence_on_kpis.time > 0
                    ? `+${influence_on_kpis.time}`
                    : influence_on_kpis.time;
            const kpiQuality =
                influence_on_kpis.quality > 0
                    ? `+${influence_on_kpis.quality}`
                    : influence_on_kpis.quality;

            const kpi_classes = "low medium high";
            $finance_class.removeClass(kpi_classes);
            $time_class.removeClass(kpi_classes);
            $quality.removeClass(kpi_classes);

            $finance
                .css("width", `${updatedKpiScoreWidth.finance}%`)
                .addClass("added")
                .append(`<span class="point-effect">${kpiFinance}</span>`);

            $time
                .css("width", `${updatedKpiScoreWidth.time}%`)
                .addClass("added")
                .append(`<span class="point-effect">${kpiTime}</span>`);

            $quality
                .css("width", `${updatedKpiScoreWidth.quality}%`)
                .addClass("added")
                .append(`<span class="point-effect">${kpiQuality}</span>`);

            setTimeout(function () {
                $(".point-effect").addClass("shown");
            }, 100);
            setTimeout(function () {
                $(".point-effect").fadeOut();
            }, 2500);
            setTimeout(function () {
                $(".point-effect").remove();
            }, 3000);

            $finance_class.addClass(updateKpiClass.finance);
            $time_class.addClass(updateKpiClass.time);
            $quality_class.addClass(updateKpiClass.quality);

            const onSuccessUpdate = () => {
                setTotalAttempt(roomId, totalAttempt);
                // this.maybeRoomIsFinish();
                this.toggleContinueBtn();
            };

            const onErrorUpdate = () => {};

            maybeUpdateRoomStatus(roomId, updatedRoomStatus);

            updateFinalRoomAnswer(roomId, updatedData)
                .then(onSuccessUpdate)
                .catch(onErrorUpdate);

            if ($theChat.next().length > 0) {
                $(elms.chatCount).html("1");
                $theChat
                    .next()
                    .find(elms.timeInfo)
                    .text(currentTime)
                    .removeClass("hidden");
                $theChat.next().removeClass("hidden");

                setTimeout(() => {
                    $theChat.next().addClass("active");
                }, 100);

                $(elms.chatList).animate({
                    scrollTop: $(elms.chatList).prop("scrollHeight"),
                });
            }

            fb.update(`${fb.roomsPath}/${roomId}`, {
                currentOpenedChat: false,
            });
        }, 2000);
    }

    getKpiClass(kpiValue) {
        if (kpiValue <= 1) {
            return "low";
        } else if (kpiValue > 1 && kpiValue <= 2) {
            return "medium";
        } else if (kpiValue >= 3) {
            return "high";
        }
    }

    calculateScore(kpi_data) {
        const { kpis_score, kpis_score_points } = this._data;
        const minimal_kpis_score = {
            finance: Number(kpis_score.finance.minimal_score),
            time: Number(kpis_score.time.minimal_score),
            quality: Number(kpis_score.quality.minimal_score),
        };
        let score = 10;
        let countKpiMetScore = 0;

        $.each(kpi_data, function (index, item) {
            if (item >= minimal_kpis_score?.[index]) countKpiMetScore++;
        });

        switch (countKpiMetScore) {
            case 1:
                score = kpis_score_points.one_kpi;
                break;
            case 2:
                score = kpis_score_points.two_kpi;
                break;
            case 3:
                score = kpis_score_points.all_kpi;
                break;
            default:
                score = 10;
                break;
        }

        return score;
    }

    toggleContinueBtn() {
        const roomId = this.roomId;

        getFinalRoomAnswers(roomId).then((data) => {
            const { conversations } = this._data;
            const totalConversations = conversations.length;
            const fbRoomAnswers = data.val();
            // @ts-ignore
            const { answers, kpi_data } = fbRoomAnswers;

            if (
                !fbRoomAnswers ||
                typeof conversations !== "object" ||
                typeof fbRoomAnswers !== "object"
            ) {
                return;
            }

            if (totalConversations == Object.keys(answers).length) {
                const score = this.calculateScore(kpi_data);

                setRoomTotalScores(roomId, score);
                // maybeUpdateRoomStatus(roomId, "is-status-completed");

                $(this.elms.continueBtn).removeClass("disabled");
            }
        });
    }

    maybeRoomIsFinished() {
        const roomId = this.roomId;
        maybeUpdateRoomStatus(roomId, "is-status-completed");

        const isRoomTimeout = getIsRoomTimeOut(roomId);
        if (isRoomTimeout) {
            this.goToRewardScreen();
        }
    }

    /* show feedback reward screen */
    goToRewardScreen() {
        const elms = this.elms;
        const roomId = this.roomId;
        const rewards = this._data.rewards || [];
        const roomScore = getRoomScore(roomId);
        const $rewardPopup = $(elms.rewardScreen);
        const teamname = CONFIG.game.teamname;
        const isTeamLeader = isLeader();
        const $completionPopUp = $(".js-room-completion");

        // @ts-ignore
        const reward = rewards.find((item) => roomScore == Number(item.points));

        let title, subtitle, description;

        if (reward?.title) {
            title = reward.title;
            title = title.replaceAll("{team_name}", teamname);
        }

        if (reward?.subtitle) subtitle = reward.subtitle;

        if (reward?.description) description = reward.description;

        $completionPopUp.removeClass("is-open");

        $rewardPopup.addClass("active");
        $rewardPopup.find(elms.rewardTitle).text(title);
        $rewardPopup.find(elms.rewardSubtitle).text(subtitle);
        $rewardPopup.find(elms.rewardDescription).html(description);
        $rewardPopup.find(elms.rewardScore).text(roomScore);

        if (isTeamLeader) updateCurrentScreen(roomId, "reward-screen");

        // hide timer hint popup
        $(".js-popup-timerhint").removeClass("is-open");
    }

    /* show customization screen */
    goToCustomizationScreen() {
        const elms = this.elms;
        const roomId = this.roomId;
        const roomScore = getRoomScore(roomId);
        const $rewardPopup = $(elms.rewardScreen);
        const $customizationPopup = $(elms.customizationScreen);
        const $score = $(elms.rewardScore);
        const $selectedCategory = $(`
            ${elms.customizationCategory}[data-score="${roomScore}"]
        `);
        const isTeamLeader = isLeader();

        $(elms.customizationCategory).each(function () {
            const $slider = $(this).find(".challange-prize__item-wrapper");
            const isInitialized = $slider.hasClass("slick-initialized");
            const sliderCustomRewardOption = {
                slidesToShow: 1,
                slidesToScroll: 1,
                infinite: false,
                dots: false,
                arrows: true,
                prevArrow: $(this).find(`.challange-prize__item-prev`),
                nextArrow: $(this).find(`.challange-prize__item-next`),
            };

            if (!isInitialized) $slider.slick(sliderCustomRewardOption);
        });

        $selectedCategory.addClass("is-selected");
        $rewardPopup.removeClass("active");
        $customizationPopup.addClass("active");
        $score.text(roomScore);

        if (isTeamLeader) updateCurrentScreen(roomId, "customisations-screen");
    }

    setSelectedLogo() {
        const elms = this.elms;
        const roomId = this.roomId;
        // const is_leader = this.isTeamLeader;
        const is_leader = isLeader();
        const roomLogo = getRoomLogo(roomId);
        const roomScore = getRoomScore(roomId);
        const $selectedCategory = $(`
            ${elms.customizationCategory}[data-score="${roomScore}"]
        `);
        const $activeSlide = $selectedCategory.find(".slick-active");
        const $theImg = $activeSlide.find(elms.logoImage);
        const selectedImg = $theImg.attr("data-image");

        // redirect player to mainroom
        const goToMainroom = () => {
            const mainRoomID = CONFIG?.game?.rooms.find(
                (key) => key.id == roomId,
            ).mainroom_id;

            if (is_leader) updateCurrentScreen(roomId, null);
            GameLogic.goToPage(mainRoomID);
        };

        if (roomLogo) goToMainroom();

        if (selectedImg == undefined) {
            goToMainroom();
            return false;
        }

        if (is_leader) {
            setTeamLogos(roomId, selectedImg)
                .then(goToMainroom)
                .catch(goToMainroom);
        } else {
            goToMainroom();
        }
    }

    closeNarrativePopup() {
        GameLogic.toggleNarrative();
    }
}
